module.exports = __webpack_public_path__ + "static/logo.emblem-f5313c5058de8d8462e6bb012d529fc9.png";